import React from 'react';
import { t } from 'i18next';
import { Box, Button, DialogContent, DialogTitle, Typography } from '@mui/material';

const Declination = (props) => {
    const { handleBack, handleConfirm } = props;

    return (
        <>
            <DialogTitle>{t('AcceptDecline.Header3')}</DialogTitle>
            <DialogContent>
                <Box>
                    <Typography sx={{ textAlign: 'left', marginBottom: '15rem' }}>{t('AcceptDecline.DeclineExplanation')}</Typography>
                </Box>

                <Box>
                    <Button
                        onClick={handleBack}
                        variant="contained"
                        sx={{ marginRight: '1rem' }}
                        color="secondary"
                    >
                        <Typography>Back</Typography>
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        variant="contained"
                        color="error"
                    >
                        <Typography>Decline scholarship</Typography>
                    </Button>
                </Box>
            </DialogContent>
        </>
    );
};

export default Declination;
